import { ApiQuery, SortDirections } from "../filters/types";
import { TokenColumns } from "./types";

// // // //

export const DEFAULT_TOKEN_LIST_QUERY: ApiQuery = {
    sort: {
        direction: SortDirections.asc,
        field: TokenColumns.name,
    },
    pagination: {
        page: 1,
        perPage: 25,
    },
};
